import styled from 'styled-components'

import { PersonalizationInfoList } from '@Components/Personalization/Styles/Personalization.styled'

export const UVInfoList = styled(PersonalizationInfoList)`
  margin-top: 8px;
`

